// Importing images
import neck from "../image/neckpain.webp";
import back from "../image/back.webp";
import shoulder from "../image/shoulder.webp";
import stroke from "../image/stroke.webp";
import knee from "../image/knee.webp";
import elbow from "../image/elbow.webp";
import wrist from "../image/wrist.webp";
import ankle from "../image/ankel.webp";
import heel from "../image/heel.webp";
import post from "../image/post.webp";
import hip from "../image/hip.webp";
import vertigo from "../image/vertigo.webp";
import bell from "../image/bell.webp";
import diabetic from "../image/diabetic.webp";
import trigeminal from "../image/trigeminal.webp";
import headache from "../image/headach.webp";
import peripheral from "../image/peripheral.webp";
import varicose from "../image/varicose.webp";
import foot from "../image/foot.webp";
import footdrop from "../image/footDrop.webp";

// Importing secondary images
import backp from "../image/backp.png";
import shoulderp from "../image/shoulderp.png";
import neckp from "../image/neckp.png";
import kneep from "../image/kneep.png";
import strokep from "../image/Strokp.png";

// Exporting servicesData array
export const servicesData = [
  {
    image: neck,
    title: "Neck Pain",
    description:
      "Neck pain manifests as discomfort, stiffness, and restricted movement due to factors like poor posture, injury, stress, or underlying conditions.",
    buttonLabel: "Book now",
  },
  {
    image: back,
    title: "Back Pain",
    description:
      "Back pain often arises from muscle strain, spinal issues, or improper posture, affecting mobility and daily activities.",
    buttonLabel: "Book now",
  },
  {
    image: shoulder,
    title: "Shoulder Pain",
    description:
      "Shoulder pain is commonly caused by injuries, arthritis, or overuse, leading to stiffness and discomfort.",
    buttonLabel: "Book now",
  },
  {
    image: elbow,
    title: "Elbow Pain",
    description:
      "Elbow pain can result from repetitive motion, injury, or joint inflammation, impacting arm movement and strength.",
    buttonLabel: "Book now",
  },
  {
    image: wrist,
    title: "Wrist Pain",
    description:
      "Wrist pain occurs due to repetitive strain, arthritis, or injury, limiting hand and finger movements.",
    buttonLabel: "Book now",
  },
  {
    image: knee,
    title: "Knee Pain",
    description:
      "Knee pain is often caused by injuries, arthritis, or strain, hindering walking and physical activities.",
    buttonLabel: "Book now",
  },
  {
    image: ankle,
    title: "Ankle Pain",
    description:
      "Ankle pain arises from sprains, fractures, or overuse, affecting mobility and balance.",
    buttonLabel: "Book now",
  },
  {
    image: heel,
    title: "Heel Pain",
    description:
      "Heel pain, often caused by plantar fasciitis or heel spurs, can make walking and standing uncomfortable.",
    buttonLabel: "Book now",
  },
  {
    image: hip,
    title: "Hip Pain",
    description:
      "Hip pain is associated with injuries, arthritis, or overuse, leading to difficulty in sitting or walking.",
    buttonLabel: "Book now",
  },
  {
    image: stroke,
    title: "Stroke Recovery",
    description:
      "Stroke recovery involves managing weakness, mobility issues, and overall rehabilitation to restore independence.",
    buttonLabel: "Book now",
  },
  {
    image: vertigo,
    title: "Vertigo",
    description:
      "Vertigo causes dizziness and balance issues, often due to inner ear problems or nervous system conditions.",
    buttonLabel: "Book now",
  },
  {
    image: bell,
    title: "Bell's Palsy",
    description:
      "Bell's Palsy leads to temporary facial weakness or paralysis due to nerve inflammation or infection.",
    buttonLabel: "Book now",
  },
  {
    image: diabetic,
    title: "Diabetic Neuropathy",
    description:
      "Diabetic neuropathy causes nerve damage due to high blood sugar levels, leading to pain and numbness.",
    buttonLabel: "Book now",
  },
  {
    image: trigeminal,
    title: "Trigeminal Neuralgia",
    description:
      "Trigeminal neuralgia results in severe facial pain due to nerve irritation or compression.",
    buttonLabel: "Book now",
  },
  {
    image: headache,
    title: "Headache / Migraine",
    description:
      "Chronic headaches and migraines can stem from various triggers, impacting daily life and productivity.",
    buttonLabel: "Book now",
  },
  {
    image: peripheral,
    title: "Peripheral Neuropathy",
    description:
      "Peripheral neuropathy involves nerve damage causing weakness, numbness, and pain, typically in the hands and feet.",
    buttonLabel: "Book now",
  },
  {
    image: varicose,
    title: "Varicose Veins",
    description:
      "Varicose veins are enlarged veins caused by poor circulation, leading to discomfort and swelling.",
    buttonLabel: "Book now",
  },
  {
    image: foot,
    title: "Foot Numbness",
    description:
      "Foot numbness is a common issue caused by nerve compression or poor circulation, affecting sensation and balance.",
    buttonLabel: "Book now",
  },
  {
    image: post,
    title: "Post-Operative Care",
    description:
      "Post-operative care focuses on recovery and rehabilitation to ensure optimal healing and return to normal activities.",
    buttonLabel: "Book now",
  },
  {
    image: footdrop,
    title: "Foot Drop",
    description:
      "Foot drop results in difficulty lifting the front of the foot, often due to nerve or muscle issues.",
    buttonLabel: "Book now",
  },
  {
    image: headache,
    title: "Other Services",
    description:
      "We offer various other physiotherapy services tailored to your specific needs and conditions.",
    buttonLabel: "Book now",
  },
];

// Exporting services array
export const services = [
  {
    id: "backPain",
    img: backp,
    title: "Back Pain",
    description:
      "Back pain is a common condition affecting many people, characterized by discomfort or pain in the lower or upper back. It can result from muscle strain, poor posture, or underlying medical conditions requiring professional physiotherapy treatment.",
    image: back,
  },
  {
    id: "neckPain",
    img: neckp,
    title: "Neck Pain",
    description:
      "Physiotherapy for neck pain offers tailored treatments like exercises, manual therapy, and posture correction to relieve discomfort, restore mobility, and prevent future issues, ensuring personalized care for optimal recovery.",
    image: neck,
  },
  {
    id: "shoulderPain",
    img: shoulderp,
    title: "Shoulder Pain",
    description:
      "Shoulder pain can result from various causes, including rotator cuff injuries, frozen shoulder, or tendonitis. Physiotherapy treatments often include exercises, stretches, and manual therapy to alleviate pain and restore shoulder function.",
    image: shoulder,
  },
  {
    id: "kneePain",
    img: kneep,
    title: "Knee Pain",
    description:
      "Effective physiotherapy for knee pain includes targeted exercises, manual therapy, and pain management techniques to enhance mobility and strength, aiming to restore function and alleviate discomfort for improved quality of life.",
    image: knee,
  },
  {
    id: "stroke",
    img: strokep,
    title: "Stroke",
    description:
      "A stroke occurs when blood flow to the brain is interrupted, leading to brain cell damage. Symptoms include sudden numbness, confusion, and difficulty speaking or walking. Immediate medical attention is crucial for treatment and recovery.",
    image: stroke,
  },
];


  const data = {
  services,
  servicesData,
};

export default data;